
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import Button from './Button';

interface PageHeaderProps {
  title: string;
  children?: string;
  onBackButtonPress?: () => void;
  buttonId?: string;
}

const PageHeader = ({ title, children, onBackButtonPress, buttonId }: PageHeaderProps) => (
  <div className="flex gap-4 items-center">
    {onBackButtonPress && (
      <Button
        id={buttonId}
        label={''}
        icon={<ChevronLeftIcon className="-ml-1 mr-2 sm:h-6 sm:w-6 h-4 w-4" aria-hidden="true" />}
        type="button"
        onClick={onBackButtonPress}
      />
    )}
    <h1>{title}</h1>
    <p>{children}</p>
  </div>
);

export default PageHeader;
